// extracted by mini-css-extract-plugin
export default {"container":"center-layout-container-bd2084"};